import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { GlobalConstants } from '../../constants/global.constant';
import { SpinnerOverlayService } from '../../services/spinner-overlay/spinner-overlay.service';

@Component({
  selector: 'iposcen-spinner-overlay',
  templateUrl: './spinner-overlay.component.html',
  styleUrls: ['./spinner-overlay.component.scss']
})
export class SpinnerOverlayComponent implements OnInit {

  loading: boolean;
  @Output() readonly getStatus = new EventEmitter<boolean>();
  @Input('isCard') isCardEnabled = false;
  @Input('isActiveUser') isActiveUserSpinner = false;
  userRole: string = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  constructor(private spinnerOverlayService: SpinnerOverlayService) {

    this.spinnerOverlayService.$isLoading.subscribe(status => {
      this.loading = status;
      this.getStatus.emit(this.loading);
    });
  }

  ngOnInit(): void {
  }
}
